export const CheckCircleIcon = (): JSX.Element => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.4 9.46875L7.8 11.8688L12.6 7.06875M17 9.46875C17 13.887 13.4183 17.4688 9 17.4688C4.58172 17.4688 1 13.887 1 9.46875C1 5.05047 4.58172 1.46875 9 1.46875C13.4183 1.46875 17 5.05047 17 9.46875Z"
      stroke="#363BC4"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
